export const COURIER_NAV_ITEMS = [
  { key: "home", label: "Home", icon: "home", href: "/delivery/courier" },
  { key: "orders", label: "Orders", icon: "orders", href: "/delivery/history" },
  { key: "earnings", label: "Earnings", icon: "earnings", href: "/delivery/earnings" },
  { key: "wallet", label: "Wallet", icon: "wallet", href: "/delivery/wallet" },
  { key: "profile", label: "Profile", icon: "profile", href: "/delivery/account" },
];
